import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientUsersEditResolverErrorStatesEnum {
    GetClientUsersFailed = ErrorStateScheduleEnum.PanelUserEditResolverStatesStartIndex,
    GetClientUserNoData,
    GetClientFailed,
    GetClientNoData,
    GetAssignedPortalsFailed,
    GetAssignedPortalsInvalidData,
    GetCountriesFailed,
    GetCountriesInvalidData
}
